
class CollectionSeoText extends HTMLElement {
    constructor() {
      super();
      this.textContentContainer = this.querySelector('.metafield-rich_text_field');
      this.seeMoreButton = this.querySelector('.collection-seo-link');
  
      if (this.textContentContainer && this.seeMoreButton) {
        this.init();
        this.seeMoreButton.addEventListener("click", this.toggleTextVisibility.bind(this));
      }
    }
  
    init() {
      if (this.isTextOverflowing(this.textContentContainer)) {
        this.seeMoreButton.style.display = "inline-block"; 
        this.collapseText(); 
      } else {
        this.seeMoreButton.style.display = "none"; 
      }
    }
  
    isTextOverflowing(container) {
      const computedStyle = window.getComputedStyle(container);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const maxLines = 2;
  
      let totalHeight = 0;
      container.childNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          totalHeight += node.offsetHeight;
        }
      });
  
      return totalHeight > lineHeight * maxLines;
    }
  
    collapseText() {
      const maxHeight = this.getLineHeight(this.textContentContainer) * 2; 
      this.textContentContainer.style.maxHeight = `${maxHeight}px`;
      this.textContentContainer.style.overflow = "hidden";
    }
  
    expandText() {
      this.textContentContainer.style.maxHeight = "1000px"; 
      this.textContentContainer.style.overflow = "visible";
    }
  
    toggleTextVisibility(event) {
      event.preventDefault();
  
      const isExpanded = this.seeMoreButton.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        this.collapseText();
        this.seeMoreButton.setAttribute("aria-expanded", "false");
        setTimeout(() => {
        this.seeMoreButton.textContent = this.seeMoreButton.getAttribute("data-see-more-text") || "See More";
      }, 200);
      } else {
        this.expandText();
        this.seeMoreButton.setAttribute("aria-expanded", "true");
        setTimeout(() => {
          this.seeMoreButton.textContent = this.seeMoreButton.getAttribute("data-see-less-text") || "See Less";
        }, 100);
      }
    }
  
    getLineHeight(element) {
      const computedStyle = window.getComputedStyle(element);
      return parseFloat(computedStyle.lineHeight);
    }
  }
  
  window.customElements.define("collection-seo-text", CollectionSeoText);